export default __webpack_public_path__ + "static/media/men39s-clothes-hanger-generative-ai (1).c062ce9c.jpg";